import React, { FC, SyntheticEvent, useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useIntl } from 'react-intl'
import { useNavigate, useParams } from 'react-router-dom'
import { SecrDocumentEditModal } from './SecDocumentEditModal'
import SecrDocumentsTable from './SecrDocumentsTable'

const SecrDocumentsList: FC = () => {
  const params = useParams()
  const navigate = useNavigate()
  const [itemIdForUpdate, setItemIdForUpdate] = useState(params.id !== 'list' ? params.id : '')
  const [refreshFunction, setRefreshFunction] = useState<any>(() => {})
  const intl = useIntl()
  return (
    <>
      <SecrDocumentsTable
        title={intl.formatMessage({ id: 'REPORTS.SECRDOCUMENTS' })}
        dataUrl='/secr_documents/list'
        editCallback={(id: any, refresh: Function) => {
          setRefreshFunction(() => refresh)
          setItemIdForUpdate(id)
          navigate('/secr_documents/' + id)
        }}
        deleteCallback={(id: any, refresh: Function) => {
          axios.get('/secr_documents/save/' + id).then((response) => {
            let csrfData = response.data.data
            Swal.fire({
              title: 'Warning',
              html: 'Are you want to delete this document?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Delete',
              cancelButtonText: 'Cancel',
              customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-primary',
              },
            }).then((result) => {
              if (result.isConfirmed) {
                axios
                  .delete('secr_documents/save/' + id, {
                    data: csrfData,
                  })
                  .then(() => {
                    navigate('/secr_documents/list')
                    refresh()
                  })
              }
            })
          })
        }}
        actionItems={[
          {
            text: intl.formatMessage({ id: 'DOCUMENTS.ADD_NEW_DOCUMENT' }),
            class: 'btn btn-sm btn-primary',
            icon: 'far fa-building',
            onClick: function (event: SyntheticEvent, refresh: Function) {
              setItemIdForUpdate('add')
              setRefreshFunction(() => refresh)
            },
          },
        ]}
      />
      {itemIdForUpdate !== '' ? (
        <SecrDocumentEditModal
          show={itemIdForUpdate !== ''}
          itemIdForUpdate={itemIdForUpdate}
          onHide={() => {
            setItemIdForUpdate('')
            navigate('/secr_documents/list')
          }}
          refreshFunction={(itemId: any) => {
            if (itemId !== undefined) {
              setItemIdForUpdate(itemId)
              navigate('/secr_documents/list')
            }
            refreshFunction()
          }}
        />
      ) : (
        <></>
      )}
    </>
  )
}

export { SecrDocumentsList }
